import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import SearchBar from '../Components/SearchBar';
import {
    getAllInvoicesForSpecialCase, getDueAmounts, setInvoicePaymentMedium, getBudgetAmount, updateStatusForFinance,
    postSplitBudget, getSplitBudget, updatePayableAmountInInvoice, updatePriority
} from '../store/actions/invoiceActions';
import { getallMasterData } from '../store/actions/masterActions';
import { connect } from 'react-redux'
import FormatDate from '../Classes/FormatDate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swal from '@sweetalert/with-react';
import { Accordion, Card } from 'react-bootstrap';
import authInstance from '../Classes/AuthHandler';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import numberWithCommas from '../Classes/NumberwithComma'
import DropdownFlat from '../Components/DropdownFlat'
import dateFormater from '../Classes/FormatDate'
import DocumentCommentAdvancePopUp from '../Components/DocumentCommentAdvancePopUp';
import toast from 'react-hot-toast';

//import { Button } from 'react-bootstrap';
import env from '../ENV';
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class ReqPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoicetabledata: [],
            approvedPaymentstabledata: [],
            supplierName: "ABC Tech Inc.",
            select: true,
            modal: false,
            checked: [],
            checkedPOID: [],
            selectAll: false,
            paymentMethod: [],
            selectedpaymentmethod: "",
            select: false,
            selected: [],
            activeEventKey: 1,
            checkedArray: [],
            dropdownarray: [
                {
                    status: 'High',
                    status: 'High'
                },
                {
                    status: 'Medium',
                    status: 'Medium'
                },
                {
                    status: 'Low',
                    status: 'Low'
                },
                {
                    status: 'Hold',
                    status: 'Hold'
                },
            ],
            roles: authInstance.getRoles(),
            budget: "", budgetamountId: "",
            Curr_Day: "",
            finalLastDay: "",
            khurdaBudget: 0,
            othersBudget: 0,
            updated_khurdaBudget: "",
            selectedKhurdaBudget: 0,
            selectedOthersBudget: 0,
            updated_othersBudget: 0,
            SplitBudgetRecordsId: 0,
            paybleAmount: "",
            DocumentCommentAdvancePopUpModal: false,
            varId: "",
            totalInvoicetabledAmt: 0,
            totalApprovedPaymentAmt: 0,
            searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
            searchForOptions: [
                {
                    label: 'Vendor Name', value: 'Vendor Name'
                },
                {
                    label: 'Plant Code', value: 'Plant Code'
                },
                {
                    label: 'PO Number', value: 'PO Number'
                },
                {
                    label: 'Invoice Number', value: 'Invoice Number'
                },
                {
                    label: 'Project No.', value: 'WBS'
                },
            ],
            searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
            searchForItem: new URLSearchParams(this.props.location.search).get("searchFor") ? [{
                label: new URLSearchParams(this.props.location.search).get("searchFor"), value: new URLSearchParams(this.props.location.search).get("searchFor")
            }] : [],

        }
        this.togglebutton = this.togglebutton.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);
        this.modal = this.modal.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handlepayment = this.handlepayment.bind(this);
        this.handlesetBudget = this.handlesetBudget.bind(this);
        this.handlekhurdaBudget = this.handlekhurdaBudget.bind(this);
        this.handleeditpaybleAmount = this.handleeditpaybleAmount.bind(this);
        this.DocumentCommentAdvancePopUpModal = this.DocumentCommentAdvancePopUpModal.bind(this);
    }

    datemanipulation() {
        var d = new Date()
        var first = d.getDate() - d.getDay();
        var EndDate = this.formatDate(new Date(d.setDate(first + 6)))
        var StartDate = this.formatDate(new Date(d.setDate(first)))

        this.setState({ Curr_Day: StartDate, finalLastDay: EndDate })
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }


    handleSelect = (e) => {

        this.setState({
            selectedpaymentmethod: e.target.value
        })
    }

    modal() {
        this.setState({ modal: !this.state.modal });
        if (this.state.modal == true) {
            this.setState({ opacity: "" })
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    modalSubmit = async () => {
        var role = Object.keys(authInstance.getRoles())[0]
        var group = Object.keys(authInstance.getGroups())[0]

        await this.props.postSplitBudget({
            BudgetAmountId: this.state.budgetamountId,
            AmountForKhurda: this.state.updated_khurdaBudget,
            AmountForOthers: this.state.updated_othersBudget,
            SplitBudgetRecordsId: this.state.SplitBudgetRecordsId
        })
        await this.modal()
        swal("Budget Updated Successfully", { icon: "success" })
        await this.dataSyns()
        // window.location.reload()
    }

    dataSyns = async () => {
        var role = Object.keys(authInstance.getRoles())[0]
        var group = Object.keys(authInstance.getGroups())[0]
        var roles = authInstance.getRoles()
        console.log(role, group)
        let searchData = {
            searchTerm: this.state.searchTerm,
            searchFor: this.state.searchFor,
        }

        this.props.history.push({
            pathname: '/SendforPayment',
            search: "?" + new URLSearchParams(searchData).toString()
        })
        if (roles[54]) {
            await this.props.getAllInvoicesForSpecialCase(10, 11, searchData)
        }
        else {

            await this.props.getAllInvoicesForSpecialCase(role, group, searchData)
        }
        if (this.props.invoices.allInvoicesSpl && this.props.invoices.allInvoicesSpl.recordset && this.props.invoices.allInvoicesSpl.recordset.length > 0) {
            // this.props.invoices.allInvoices.recordset.map()
            let invoicetabledata = [];
            let totalInvoicetabledAmt = 0;
            let approvedPaymentstabledata = [];
            let totalApprovedPaymentAmt = 0;
            await this.props.invoices.allInvoicesSpl.recordset.map((item) => {
                if (item.InvoiceStatusId != 7) {
                    let itemData = item
                    totalInvoicetabledAmt = parseFloat(totalInvoicetabledAmt) + parseFloat(item.PayableAmount)
                    itemData.NewPayableAmount = 0;
                    invoicetabledata.push(itemData)
                } else if (item.InvoiceStatusId == 7 && item.TotalPaidAmount === 0) {
                    let itemData = item
                    totalApprovedPaymentAmt = parseFloat(totalApprovedPaymentAmt) + parseFloat(item.PayableAmount)
                    itemData.NewPayableAmount = 0;
                    approvedPaymentstabledata.push(itemData)
                }
            })
            console.log(parseFloat(totalInvoicetabledAmt).toFixed(2), 'totalInvoicetabledAmt')
            // await console.log(invoicetabledata, 'invoicetabledata')
            await this.setState({ invoicetabledata, approvedPaymentstabledata, totalInvoicetabledAmt: parseFloat(totalInvoicetabledAmt).toFixed(2), totalApprovedPaymentAmt: parseFloat(totalApprovedPaymentAmt).toFixed(2), checkedArray: [] })
        }

        await this.props.getDueAmounts()
        await this.props.getallMasterData()
        var EndDate = this.state.finalLastDay
        var StartDate = this.state.Curr_Day
        await this.props.getBudgetAmount({
            StartDate: StartDate,
            EndDate: EndDate
        })
        await this.props.getSplitBudget({
            StartDate: StartDate,
            EndDate: EndDate
        })

        if (this.props.masterReducerData.loading == false) {
            let paymentMethod = await this.props.masterReducerData.masterdata.recordset
            await this.setState({ paymentMethod })
        }

        if (this.props.invoices.loading == false) {
            let budget = this.props.invoices.budgetamount.recordset && this.props.invoices.budgetamount.recordset.length > 0 ? this.props.invoices.budgetamount.recordset[0].Amount : 0
            let budgetamountId = this.props.invoices.budgetamount.recordset && this.props.invoices.budgetamount.recordset.length > 0 ? this.props.invoices.budgetamount.recordset[0].BudgetAmmountId : 0
            await this.setState({ budget, budgetamountId })
        }

        if (this.props.invoices.getsplitAmountData &&
            this.props.invoices.getsplitAmountData.recordset
            && this.props.invoices.getsplitAmountData.recordset.length > 0) {
            let khurdaBudget = this.props.invoices.getsplitAmountData.recordset[0].AmountForKhurda
            let othersBudget = this.props.invoices.getsplitAmountData.recordset[0].AmountForOthers
            let SplitBudgetRecordsId = this.props.invoices.getsplitAmountData.recordset[0].SplitBudgetRecordsId
            await this.setState({ khurdaBudget, othersBudget, SplitBudgetRecordsId })
        }


    }

    componentDidMount = async () => {
        await this.datemanipulation()
        await this.dataSyns()
    }

    handlepayment = async () => {
        let array = []
        let uniqueArray = [...new Set(this.state.checkedArray)];
        uniqueArray.map(item => {
            array.push(item)
        })
        let totalBudget = 0;
        let totalKhurdaBudget = 0;

        var roles = authInstance.getRoles()
        var invoicetabledata = [...this.state.invoicetabledata]
        if (roles[10]) {
            for (let index = 0; index < invoicetabledata.length; index++) {
                const item = await invoicetabledata[index]
                if (uniqueArray.includes(item.InvoiceId) && item.PlantCode !== '8501' && item.PlantCode !== '8502') {
                    totalBudget = await totalBudget + parseFloat(item.PayableAmount)
                }
                if (uniqueArray.includes(item.InvoiceId) && (item.PlantCode === '8501' || item.PlantCode === '8502')) {
                    totalKhurdaBudget = await totalKhurdaBudget + parseFloat(item.PayableAmount)
                }
            }

            console.log(numberWithCommas(parseFloat(totalBudget)), numberWithCommas(parseFloat(this.state.othersBudget)), totalBudget == this.state.othersBudget ? 'true' : 'false', 'Budget Amount for Gurgaon & Others')
            console.log(numberWithCommas(parseFloat(totalKhurdaBudget)), numberWithCommas(parseFloat(this.state.khurdaBudget)), totalBudget == this.state.othersBudget ? 'true' : 'false', 'Budget Amount for Khurda')

            if (totalBudget > this.state.othersBudget) {
                swal("Please check the Payable Amount - Avaiable Budget Amount for Gurgaon & Others : " + numberWithCommas(parseFloat(this.state.othersBudget)), { icon: "error" })
                return false;
            }

            if (totalKhurdaBudget > this.state.khurdaBudget) {
                swal("Please check the Payable Amount - Avaiable Budget Amount for Khurda : " + numberWithCommas(parseFloat(this.state.khurdaBudget)), { icon: "error" })
                return false;
            }

        }

        console.log(invoicetabledata.find(item => uniqueArray.includes(item.InvoiceId)))
        // return false;
        for (let i = 0; i < array.length; i++) {
            if (roles[10]) {
                await this.props.updateStatusForFinance(7, array[i])
                swal("Payment Approved Successfully", { icon: "success" })
            } else {
                await this.props.updateStatusForFinance(6, array[i])
                swal("Payment Approved Successfully", { icon: "success" })
            }
        }
        await this.dataSyns()
        // this.props.getAllInvoices(role,group)
    }

    handlesetBudget() {
        // console.log("BudgetAmountID=",this.state.budgetamountId,"khurdaBudget=", this.state.khurdaBudget, "othersBudget=", this.state.othersBudget)
        this.props.postSplitBudget({
            BudgetAmountId: this.state.budgetamountId,
            AmountForKhurda: this.state.khurdaBudget,
            AmountForOthers: this.state.othersBudget,
            SplitBudgetRecordsId: this.state.SplitBudgetRecordsId
        })
        window.location.reload()
    }

    handlepaybleamount = (value, InvoiceAmount, Index) => {
        let invoicetabledata = [...this.state.invoicetabledata]
        console.log(value, InvoiceAmount, typeof (value), typeof (InvoiceAmount), "*******************8")
        if (this.state.roles[7] || this.state.roles[12]) {
            if (parseFloat(value) <= parseFloat(InvoiceAmount)) {
                invoicetabledata[Index].PayableAmount = value
                this.setState({ paybleAmount: value, invoicetabledata: invoicetabledata })
            } else {
                swal("Please check the Payable Amount", { icon: "error" })
            }
        }
        if (this.state.roles[10]) {
            if (parseFloat(value) <= parseFloat(InvoiceAmount) && parseFloat(value) > 0) {
                invoicetabledata[Index].PayableAmount = value
                this.setState({ paybleAmount: value, invoicetabledata: invoicetabledata })
            } else {
                swal("Please check the Payable Amount", { icon: "error" })
            }
        }
    }

    handleeditpaybleAmount = async (invoiceID) => {
        console.log(invoiceID, this.state.paybleAmount)
        var group = Object.keys(authInstance.getGroups())[0]
        await this.props.updatePayableAmountInInvoice(invoiceID, this.state.paybleAmount, group)

        await this.dataSyns()
    }

    handleChange = async () => {
        let select = !this.state.select;
        var checkedArray = []
        await this.state.invoicetabledata.map((item, index) => {
            if (select == true) {
                checkedArray.push(item.InvoiceId)
            }
        });
        await this.setState({ select: select, checkedArray });
        await this.setBudget()
    };

    handlekhurdaBudget = (e) => {
        let khurdaBudget = parseFloat(e.target.value), othersBudget = this.state.budget - khurdaBudget
        if (khurdaBudget > this.state.budget) {
            swal("Please check the Allocated Budget Amount for Khurda", { icon: "error" })
            this.setState({ khurdaBudget: "", othersBudget: "" })
        }
        else {
            this.setState({ khurdaBudget: parseFloat(khurdaBudget).toFixed(2), othersBudget: parseFloat(othersBudget).toFixed(2) })
        }
    }

    handleupdatekhurdaBudget = async (value) => {
        let updated_khurdaBudget = parseFloat(value)
        let updated_othersBudget = (parseFloat(this.state.budget) - updated_khurdaBudget)
        console.log(updated_othersBudget, "BUDGET DATA")
        if (updated_khurdaBudget > this.state.budget) {
            swal("Please check the Allocated Budget Amount for Khurda", { icon: "error" })
            await this.setState({ updated_khurdaBudget: "", updated_othersBudget: "" })
        }
        else {
            await this.setState({ updated_khurdaBudget: parseFloat(updated_khurdaBudget).toFixed(2), updated_othersBudget: parseFloat(updated_othersBudget).toFixed(2) })
        }
    }

    togglebutton = (Index) => {
        var multiCollapseIndex = this.state.multiCollapseIndex

        if (multiCollapseIndex != Index || multiCollapseIndex == '') {

            this.setState({ multiCollapseIndex: Index })
        }
    }
    handleSingleCheckboxChange = async (InvoiceId) => {
        var checkedArray = [...this.state.checkedArray]
        if (!checkedArray.includes(InvoiceId)) {
            checkedArray.push(InvoiceId)
        } else {
            checkedArray = checkedArray.filter(item => item !== InvoiceId)
        }
        await this.setState({ checkedArray });
        await this.setBudget()
    };

    setBudget = async () => {
        var checkedArray = [...this.state.checkedArray]
        let totalBudget = 0;
        let totalKhurdaBudget = 0;

        var roles = authInstance.getRoles()
        var invoicetabledata = [...this.state.invoicetabledata]
        if (roles[10]) {
            for (let index = 0; index < invoicetabledata.length; index++) {
                const item = await invoicetabledata[index];
                if (checkedArray.includes(item.InvoiceId) && item.PlantCode !== '8501' && item.PlantCode !== '8502') {
                    totalBudget = await totalBudget + parseFloat(item.PayableAmount)
                }
                if (checkedArray.includes(item.InvoiceId) && (item.PlantCode === '8501' || item.PlantCode === '8502')) {
                    totalKhurdaBudget = await totalKhurdaBudget + parseFloat(item.PayableAmount)
                }
            }

            // if (totalBudget > this.state.othersBudget) {
            //     swal("Please check the Payable Amount - Avaiable Budget Amount for Gurgaon & Others : " + this.state.othersBudget, { icon: "error" })
            //     return false;
            // }

            // if (totalKhurdaBudget > this.state.khurdaBudget) {
            //     swal("Please check the Payable Amount - Avaiable Budget Amount for Khurda : " + this.state.khurdaBudget, { icon: "error" })
            //     return false;
            // }
            await this.setState({
                selectedKhurdaBudget: parseFloat(totalKhurdaBudget).toFixed(2),
                selectedOthersBudget: parseFloat(totalBudget).toFixed(2)
            })

        }
    }

    fetchDate(date) {
        let dd = date.getDate().toString()
        let mm = (date.getMonth() + 1).toString()
        if (dd.length < 2)
            dd = "0" + dd
        if (mm.length < 2)
            mm = "0" + mm
        let finalDate = dd + "/" + mm + "/" + date.getFullYear();
        return finalDate;
    }
    daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
    }

    DocumentCommentAdvancePopUpModal() {
        this.setState({ DocumentCommentAdvancePopUpModal: !this.state.DocumentCommentAdvancePopUpModal });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.DocumentCommentAdvancePopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleDocumentCommentAdvancePopUpModal = async (e) => {
        await this.setState({ DocumentCommentAdvancePopUpModal: !this.state.DocumentCommentAdvancePopUpModal });
        if (this.state.DocumentCommentAdvancePopUpModal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", varId: "" }
            )
        }
    }

    rowClick = async (index) => {

        let id = this.state.invoicetabledata[index].InvoiceId
        console.log(id, "idddd")
        await this.setState({ varId: id })
        await this.DocumentCommentAdvancePopUpModal(id)
    }

    handleRemarks = async (e, Index) => {
        if (e.target.value.length > 120) {
            swal("Word Limit Exceeded", { button: true, icon: "error" })
            return false
        }
        let invoicetabledata = [...this.state.invoicetabledata]
        invoicetabledata[Index].Remarks = e.target.value
        await this.setState({ invoicetabledata })
        // console.log(tableData[Index].Remarks,"||||||||||||||||")
    }

    handleDropdowndata = async (e, item) => {
        await this.props.updatePriority(item.InvoiceId, e.target.value, authInstance.getUserID(), authInstance.getUserPayLoad().fullName).then(async () => {
            await this.dataSyns()
        })
    }
    handleRevise = async () => {
        let array = [...new Set(this.state.checkedArrayRecall)];

        console.log(array, "77777777")
        for (let i = 0; i < array.length; i++) {
            await this.props.updateStatusForFinance(6, array[i]).then(() => {
                toast.success(`Recall Successfull`, {
                    duration: 1000
                });
            })
        }
        await this.setState({ checkedArrayRecall: [], selectRecall: false })
        await this.dataSyns()
    }
    handleISearch = (e) => {
        let searchTerm = e.target.value
        this.setState({
            searchTerm
        })
        console.log(this.state.searchTerm)
    }
    handleSearching = async (e) => {
        await this.dataSyns()
    }

    clearFilter = async () => {
        await this.setState({
            searchTerm: '',
            searchFor: '',
            searchForItem: [],
        })
        await this.dataSyns()
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }

    render() {
        // console.log(this.props.masterReducerData.masterdata.recordset)

        var roles = authInstance.getRoles()
        var groups = authInstance.getGroups()
        var varId = this.state.varId

        // console.log(roles, groups)

        return (

            <div className="Container-fluid pageheight pl-2 pr-2 pt-2"  >
                {/*----------Document comment-------------- */}
                {
                    varId ? (<DocumentCommentAdvancePopUp action={this.state.DocumentCommentAdvancePopUpModal} toggleDocumentCommentAdvancePopUpModal={(e) => this.toggleDocumentCommentAdvancePopUpModal(e)} InvoiceId={varId} path='/RequestPayment' />) : null
                }
                {/*----------Document Comment end  */}


                <Modal isOpen={this.state.modal} className="modal-lg">
                    <div className={"modal-bg" + (this.state.modal === 'false' ? 'open' : '')}>
                        <div className="modalheads">
                            <ModalHeader HeaderStyle="modal-header">
                                <div><h4 >Update Budget Amount</h4></div>
                                <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>
                        </div>

                        <div >
                            <ModalBody Style="modal-body">
                                <div className="col-md-12 pt-2">
                                    <div className="form-group row" >
                                        <label for="input" className="col-md-6 form-label">
                                            <b>Budget Amount for Khurda</b>
                                            <p> {this.state.Curr_Day} to {this.state.finalLastDay}:</p>
                                        </label>
                                        <div className="input-group mb-5 col-sm-5 mt-2">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.state.updated_khurdaBudget} onValueChange={(value, name) => this.handleupdatekhurdaBudget(value)} />
                                        </div>
                                    </div>

                                    <div className="form-group row" >
                                        <label for="input" className="col-md-6 form-label">
                                            <b>Budget Amount for Gurgaon & Others</b>
                                            <p> {this.state.Curr_Day} to {this.state.finalLastDay}:</p>
                                        </label>
                                        <div className="input-group mb-5 col-sm-5 mt-2">
                                            <div className="input-group-prepend ">
                                                <span className="input-group-text">INR</span>
                                            </div>
                                            <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.state.updated_othersBudget} readOnly />
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>
                        </div>
                        <div>
                            <ModalFooter FooterStyle="modal-footer">
                                <div>
                                    <button className="btn2 btn-sms1 mt-2 ml-4 float-right rounded-pill" onClick={this.modalSubmit} type="submit">Update</button>
                                    <button type="button" className="btn2 btn-sms1 mt-2 float-right rounded-pill" onClick={this.modal}> Cancel </button>
                                </div>
                            </ModalFooter>
                        </div>
                    </div>
                </Modal>

                {/* <div className="row pl-3 header">
                    <b>REQUESTED PAYMENTS</b>
                </div> */}

                <div className="row pt-2 pr-4">
                    <div className="col-2">
                        <b>REQUESTED PAYMENTS</b>
                    </div>
                    <div className="col-4">
                        {
                            roles[10] ?
                                <button className="btn2 btn-sms1 float-right rounded-pill" type="submit" onClick={() => this.modal()}> Split Budget </button>
                                : null
                        }
                        {
                            roles[10] ?
                                <button className="btn2 btn-sms1 float-right rounded-pill" type="submit" onClick={() => this.handlepayment()}> Approve Payment </button>
                                : null
                        }
                        {
                            // roles[10] ?
                            //     <button className="btn2 btn-sms1 float-right rounded-pill" style={{ marginRight: "2.4rem" }} onClick={() => this.handleRevise()} > Recall </button>
                            //     : null
                        }
                    </div>

                    <div className="col-6">
                        <div className="from-group " >
                            <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" clearFilter={this.clearFilter} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                        </div>
                    </div>
                </div>

                <div className="col-12 pr-4">
                    <div className="border-radius-modal border-color p-2">

                        <div className="form-group row mb-0" >
                            <div className="col ">
                                <label for="input" className=" form-label" ><b>Already Due:</b></label>
                            </div>
                            <div className="col ">
                                <label for="input" className="form-label"><b>Due In Current Week:</b></label>
                            </div>
                            <div className="col">
                                <label for="input" className="form-label"><b>Subsequent Due:</b></label>
                            </div>
                            <div className="col ">
                                <label for="input" className="form-label" ><b>Total Due:</b></label>
                            </div>
                            <div className="col">
                                <label for="input" className="form-label">
                                    <b>Total Available Budget:</b>
                                </label>
                            </div>
                        </div>
                        <div className="form-group row" >
                            <div className="col">
                                {(this.props.invoices.loading == false) ?

                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.props.invoices.dueAmounts.alreadyDue} readOnly />
                                    </div>
                                    :
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value="INR 0000" readOnly />
                                    </div>
                                }
                            </div>
                            <div className="col ">
                                {(this.props.invoices.loading == false) ?
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.props.invoices.dueAmounts.currentWeekDue} readOnly />
                                    </div>

                                    :
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value="INR 0000" readOnly />
                                    </div>
                                }
                            </div>
                            <div className="col ">
                                {(this.props.invoices.loading == false) ?
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.props.invoices.dueAmounts.subsequentDue} readOnly />
                                    </div>

                                    :
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value="INR 0000" readOnly />
                                    </div>

                                }
                            </div>
                            <div className="col ">
                                {(this.props.invoices.loading == false) ?
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.props.invoices.dueAmounts.totalDue} readOnly />
                                    </div>

                                    :
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value="INR 0000" readOnly />
                                    </div>

                                }
                            </div>
                            <div className="col ">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text">INR</span>
                                    </div>
                                    <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.state.budget} readOnly />
                                </div>

                            </div>
                        </div>
                        <div className="form-group row mb-0" >
                            <div className="col">
                                <label for="input" className="form-label">
                                    <b>Budget Amount for Gurgaon & Others:</b>
                                </label>
                            </div>
                            <div className="col">
                                <label for="input" className="form-label">
                                    <b>Approved Amount for Gurgaon & Others:</b>
                                </label>
                            </div>
                            <div className="col">
                                <label for="input" className="form-label">
                                    <b>Budget Amount for Khurda</b>
                                </label>
                            </div>
                            <div className="col">
                                <label for="input" className="form-label">
                                    <b>Approved Amount for Khurda</b>
                                </label>
                            </div>
                            <div className="col">
                                <label for="input" className=" form-label"><b>Total Approved Amount:</b></label>
                            </div>
                        </div>
                        <div className="form-group row mb-0" >
                            <div className="col">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text">INR</span>
                                    </div>
                                    <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.state.othersBudget} readOnly />
                                </div>

                            </div>
                            <div className="col">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text">INR</span>
                                    </div>
                                    <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.state.selectedOthersBudget} readOnly />
                                </div>

                            </div>
                            <div className="col">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text">INR</span>
                                    </div>
                                    <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.state.khurdaBudget} readOnly onChange={this.handlekhurdaBudget} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend ">
                                        <span className="input-group-text">INR</span>
                                    </div>
                                    <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.state.selectedKhurdaBudget} readOnly onChange={this.handlekhurdaBudget} />
                                </div>
                            </div>
                            <div className="col">
                                {(this.props.invoices.loading == false) ?
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={this.state.totalApprovedPaymentAmt} readOnly />
                                    </div>

                                    :
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value="INR 0000" readOnly />
                                    </div>

                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Accordion defaultActiveKey="0" flush>
                    <Card event>
                        <Accordion.Toggle as={"h5"} className="accordion-background mb-0 pb-2 pl-2 pr-4 pt-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(1)} onClick={() => this.setState({ activeEventKey: JSON.stringify(1) })}>
                            <div className="row pl-2 pr-2">
                                <div className="col-md-9">
                                    Invoices in payment process
                                </div>
                                <div className="col-md-3">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.totalInvoicetabledAmt} readOnly />
                                    </div>
                                </div>
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={JSON.stringify(1)}>
                            <Card.Body>
                                <div className="w-block pr-4 pt-3 sticky" >
                                    <div className="scrolling-bar-table wrap">
                                        <table border="1" className="table1 payment-table" >
                                            <tr className="headerbar sticky-inner">
                                                {roles[10] ?
                                                    <th><input type="checkbox" onClick={this.handleChange} checked={this.state.select} /></th>
                                                    : null}
                                                <th style={{ whitespace: "break-spaces" }}>Plant Code</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "249px" }}>Vendor Name</th>
                                                <th style={{ whitespace: "break-spaces" }}>Vendor Type</th>
                                                <th style={{ whitespace: "break-spaces" }}>Project code</th>
                                                <th style={{ whitespace: "break-spaces" }}>PO No</th>
                                                <th style={{ whitespace: "break-spaces" }}>Invoice No</th>
                                                <th style={{ whitespace: "break-spaces" }}>Payment Counter</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "99px" }}>Invoice Date</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "149px" }}>Invoice Type</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "99px" }}>Due Date</th>
                                                <th style={{ minWidth: "171px" }}>Invoice Amount</th>
                                                <th>Invoice Amount (INR)</th>
                                                <th style={{ minWidth: "171px" }}>Net Payable Amount (INR)</th>
                                                <th style={{ minWidth: "171px" }}>Approved Amount (INR)</th>
                                                <th style={{ minWidth: "171px" }}>Balance Amount (INR)</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "99px" }}>Approval Date</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "171px" }}>Priority</th>
                                                <th style={{ whitespace: "break-spaces" }}>Acted Person</th>
                                            </tr>
                                            {/* {this.props.invoices.allInvoicesSpl.recordset.map((item) => ( */}
                                            {/* {this.props.invoices.allInvoices && this.props.invoices.allInvoices.recordset && this.props.invoices.allInvoices.recordset.length>0 && this.props.invoices.allInvoices.recordset.map((item,Index)=> */}
                                            {(this.props.invoices.loading == false) ?
                                                this.props.invoices.allInvoicesSpl && this.props.invoices.allInvoicesSpl.recordset && this.props.invoices.allInvoicesSpl.recordset.length > 0 && this.state.invoicetabledata.map((item, Index) =>
                                                    <tr className="rows headeralign">
                                                        {roles[10] ?
                                                            <td><input type="checkbox" disabled={item.InvoiceStatusId == '7' || item.Priority == 'Hold' ? true : false} checked={this.state.checkedArray.includes(item.InvoiceId) ? true : false} onChange={(event) => this.handleSingleCheckboxChange(item.InvoiceId)} value="" /></td>
                                                            : null}
                                                        {/* <td>{item.InvoiceId}</td>*/}
                                                        <td>{item.PlantCode}</td>
                                                        <td>{item.VendorName + " - " + item.VendorSapId}</td>
                                                        <td>{item.SSIType == "" ? "NON MSME" : "MSME"}</td>
                                                        <td>{item.WBSNo ? (item.WBSNo).substring(0, 6) : ''}</td>
                                                        <td>{item.POSAPId}</td>
                                                        <td>{item.InvoiceNo}</td>
                                                        <td>{(item.Counter > 0 ? `Part-${item.Counter}` : '')}</td>
                                                        <td>{item.InvoiceDate ? dateFormater(item.InvoiceDate) : ''}</td>
                                                        <td>{item.PaymentTypeName + " Against " + item.TypeFor}</td>
                                                        <td>{item.DueDate ? dateFormater(item.DueDate) : ''}</td>
                                                        {/* <td>{item.Location}</td> */}
                                                        <td className="align-middle amount-text">{`${item.CurrencyType} ${numberWithCommas(parseFloat(item.InvoiceAmount))}`}</td>
                                                        <td className="align-middle amount-text">{numberWithCommas(item.InvoiceAmountinINR)}</td>
                                                        <td className="align-middle amount-text">{item.NetPayableAmount}</td>
                                                        <td className="amount-text">
                                                            {item.InvoiceStatusId == '7' ?
                                                                numberWithCommas(parseFloat(item.PayableAmount))
                                                                :
                                                                roles[10] || item.PriorityActedId == authInstance.getUserID() || item.PriorityActedId == null ?
                                                                    <>
                                                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={item.PayableAmount} onValueChange={(value, name) => this.handlepaybleamount(value, item.NetPayableAmount, Index)} />
                                                                        <FontAwesomeIcon className="mt-2 headeralign" icon={"check-circle"} title="Approved" color={"green"} size="lg" onClick={() => this.handleeditpaybleAmount(item.InvoiceId)} />
                                                                    </>
                                                                    : numberWithCommas(parseFloat(item.PayableAmount))}

                                                        </td>
                                                        <td className="align-middle amount-text"> {numberWithCommas(parseFloat(item.NetPayableAmount) - parseFloat(item.PayableAmount))}</td>
                                                        <td>{item.ApprovalDate ? dateFormater(item.ApprovalDate) : ''}</td>
                                                        {/* <td>{item.CurrencyType}</td> */}
                                                        <td>
                                                            {(roles[7] || roles[12]) ?
                                                                item.InvoiceStatusId != '7' && (item.PriorityActedId == authInstance.getUserID() || item.PriorityActedId == null) ?
                                                                    <DropdownFlat selectedValue={item.Priority} defaultopt="Select Option" data={this.state.dropdownarray} actions={(e) => this.handleDropdowndata(e, item)} keyObjName={"status"} valueObjName={"status"} />
                                                                    :
                                                                    <>
                                                                        {item.Priority == "Low" ?
                                                                            <span className="badge badge-danger">Low</span>
                                                                            : item.Priority == "Hold" ?
                                                                                <span className="badge badge-warning">Hold</span>
                                                                                : item.Priority == "Midum" ?
                                                                                    <span className="badge badge-primary">Medium</span>
                                                                                    : <span className="badge badge-success">High</span>
                                                                        }
                                                                        <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(Index)} />
                                                                    </>
                                                                : <>
                                                                    {item.Priority == "Low" ?
                                                                        <span className="badge badge-danger">Low</span>
                                                                        : item.Priority == "Hold" ?
                                                                            <span className="badge badge-warning">Hold</span>
                                                                            : item.Priority == "Midum" ?
                                                                                <span className="badge badge-primary">Medium</span>
                                                                                : <span className="badge badge-success">High</span>
                                                                    }
                                                                    <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(Index)} />
                                                                </>}
                                                        </td>
                                                        <td>{item.FullName ? item.FullName : ''}</td>
                                                    </tr>
                                                )
                                                : null}
                                        </table>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                <Accordion defaultActiveKey="0" flush>
                    <Card event>
                        <Accordion.Toggle as={"h5"} className="accordion-background mb-0 pb-2 pl-2 pr-4 pt-2" style={{ cursor: 'pointer' }} eventKey={JSON.stringify(2)} onClick={() => this.setState({ activeEventKey: JSON.stringify(2) })}>
                            <div className="row pl-2 pr-2">
                                <div className="col-md-9">
                                    Approved Invoices
                                </div>
                                <div className="col-md-3">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <span className="input-group-text">INR</span>
                                        </div>
                                        <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.totalApprovedPaymentAmt} readOnly />
                                    </div>
                                </div>
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={JSON.stringify(2)}>
                            <Card.Body>
                                <div className="w-block pr-4 pt-3 sticky" >
                                    <div className="scrolling-bar-table wrap">
                                        <table border="1" className="table1 payment-table" >
                                            <tr className="headerbar sticky-inner">
                                                {/* {roles[10] ?
                                                    <th><input type="checkbox" onClick={this.handleChange} checked={this.state.select} /></th>
                                                    : null} */}
                                                <th style={{ whitespace: "break-spaces" }}>Plant Code</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "249px" }}>Vendor Name</th>
                                                <th style={{ whitespace: "break-spaces" }}>Vendor Type</th>
                                                <th style={{ whitespace: "break-spaces" }}>Project code</th>
                                                <th style={{ whitespace: "break-spaces" }}>PO No</th>
                                                <th style={{ whitespace: "break-spaces" }}>Invoice No</th>
                                                <th style={{ whitespace: "break-spaces" }}>Payment Counter</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "99px" }}>Invoice Date</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "149px" }}>Invoice Type</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "99px" }}>Due Date</th>
                                                <th style={{ minWidth: "171px" }}>Invoice Amount</th>
                                                <th>Invoice Amount (INR)</th>
                                                <th style={{ minWidth: "171px" }}>Net Payable Amount (INR)</th>
                                                <th style={{ minWidth: "171px" }}>Approved Amount (INR)</th>
                                                <th style={{ minWidth: "171px" }}>Balance Amount (INR)</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "99px" }}>Approval Date</th>
                                                <th style={{ whitespace: "break-spaces", minWidth: "171px" }}>Priority</th>
                                                <th style={{ whitespace: "break-spaces" }}>Acted Person</th>
                                            </tr>
                                            {/* {this.props.invoices.allInvoicesSpl.recordset.map((item) => ( */}
                                            {/* {this.props.invoices.allInvoices && this.props.invoices.allInvoices.recordset && this.props.invoices.allInvoices.recordset.length>0 && this.props.invoices.allInvoices.recordset.map((item,Index)=> */}
                                            {(this.props.invoices.loading == false) ?
                                                this.props.invoices.allInvoicesSpl && this.props.invoices.allInvoicesSpl.recordset && this.props.invoices.allInvoicesSpl.recordset.length > 0 && this.state.approvedPaymentstabledata.map((item, Index) =>
                                                    <tr className="rows headeralign">
                                                        {/* {roles[10] ?
                                                            <td><input type="checkbox" disabled={item.InvoiceStatusId == '7' || item.Priority == 'Hold' ? true : false} checked={this.state.checkedArray.includes(item.InvoiceId) ? true : false} onChange={(event) => this.handleSingleCheckboxChange(item.InvoiceId)} value="" /></td>
                                                            : null} */}
                                                        {/* <td>{item.InvoiceId}</td>*/}
                                                        <td>{item.PlantCode}</td>
                                                        <td>{item.VendorName + " - " + item.VendorSapId}</td>
                                                        <td>{item.SSIType == "" ? "NON MSME" : "MSME"}</td>
                                                        <td>{item.WBSNo ? (item.WBSNo).substring(0, 6) : ''}</td>
                                                        <td>{item.POSAPId}</td>
                                                        <td>{item.InvoiceNo}</td>
                                                        <td>{(item.Counter > 0 ? `Part-${item.Counter}` : '')}</td>
                                                        <td>{item.InvoiceDate ? dateFormater(item.InvoiceDate) : ''}</td>
                                                        <td>{item.PaymentTypeName + " Against " + item.TypeFor}</td>
                                                        <td>{item.DueDate ? dateFormater(item.DueDate) : ''}</td>
                                                        {/* <td>{item.Location}</td> */}
                                                        <td className="align-middle amount-text">{`${item.CurrencyType} ${numberWithCommas(parseFloat(item.InvoiceAmount))}`}</td>
                                                        <td className="align-middle amount-text">{numberWithCommas(item.InvoiceAmountinINR)}</td>
                                                        <td className="align-middle amount-text">{item.NetPayableAmount}</td>
                                                        <td className="amount-text">
                                                            {item.InvoiceStatusId == '7' ?
                                                                numberWithCommas(parseFloat(item.PayableAmount))
                                                                :
                                                                roles[10] || item.PriorityActedId == authInstance.getUserID() || item.PriorityActedId == null ?
                                                                    <>
                                                                        <CurrencyInput allowNegativeValue={false} className="form-control text-center" decimalScale="2" value={item.PayableAmount} onValueChange={(value, name) => this.handlepaybleamount(value, item.NetPayableAmount, Index)} />
                                                                        <FontAwesomeIcon className="mt-2 headeralign" icon={"check-circle"} title="Approved" color={"green"} size="lg" onClick={() => this.handleeditpaybleAmount(item.InvoiceId)} />
                                                                    </>
                                                                    : numberWithCommas(parseFloat(item.PayableAmount))}

                                                        </td>
                                                        <td className="align-middle amount-text"> {numberWithCommas(parseFloat(item.NetPayableAmount) - parseFloat(item.PayableAmount))}</td>
                                                        <td>{item.ApprovalDate ? dateFormater(item.ApprovalDate) : ''}</td>
                                                        {/* <td>{item.CurrencyType}</td> */}
                                                        <td>
                                                            {(roles[7] || roles[12]) ?
                                                                item.InvoiceStatusId != '7' && (item.PriorityActedId == authInstance.getUserID() || item.PriorityActedId == null) ?
                                                                    <DropdownFlat selectedValue={item.Priority} defaultopt="Select Option" data={this.state.dropdownarray} actions={(e) => this.handleDropdowndata(e, item)} keyObjName={"status"} valueObjName={"status"} />
                                                                    :
                                                                    <>
                                                                        {item.Priority == "Low" ?
                                                                            <span className="badge badge-danger">Low</span>
                                                                            : item.Priority == "Hold" ?
                                                                                <span className="badge badge-warning">Hold</span>
                                                                                : item.Priority == "Midum" ?
                                                                                    <span className="badge badge-primary">Medium</span>
                                                                                    : <span className="badge badge-success">High</span>
                                                                        }
                                                                        <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(Index)} />
                                                                    </>
                                                                : <>
                                                                    {item.Priority == "Low" ?
                                                                        <span className="badge badge-danger">Low</span>
                                                                        : item.Priority == "Hold" ?
                                                                            <span className="badge badge-warning">Hold</span>
                                                                            : item.Priority == "Midum" ?
                                                                                <span className="badge badge-primary">Medium</span>
                                                                                : <span className="badge badge-success">High</span>
                                                                    }
                                                                    <FontAwesomeIcon icon={"sms"} style={{ marginLeft: "10px" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(Index)} />
                                                                </>}
                                                        </td>
                                                        <td>{item.FullName ? item.FullName : ''}</td>
                                                    </tr>
                                                )
                                                : null}
                                        </table>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ invoices: state.invoice, masterReducerData: state.masterReducer })
export default connect(mapStateToProps, { getAllInvoicesForSpecialCase, getDueAmounts, setInvoicePaymentMedium, getallMasterData, getBudgetAmount, updateStatusForFinance, postSplitBudget, getSplitBudget, updatePayableAmountInInvoice, updatePriority })(ReqPayment)
